import React, { useEffect, useState } from 'react';
import API from '../../api';
import { useParams, useNavigate } from 'react-router-dom';
import MessageModal from '../smallComponent/MessageModal';
import { addActivity } from '../../utils/activityService';
import {API_IMAGE_URL} from '../../lib/api'

const CustomerMarkDone = () => {
 

  const { customerId } = useParams();
  const navigate = useNavigate();

  const [customer, setCustomer] = useState({});
  const [developers, setDevelopers] = useState([]);
  const [price, setPrice] = useState(0);
  const [advance, setAdvance] = useState(0);
  const [quotation, setQuotation] = useState(null);
  const [workDetails, setWorkDetails] = useState('');
  const [doneDate, setDoneDate] = useState('');
  const [modal, setModal] = useState({ show: false, type: '', title: '', message: '' });

  useEffect(() => {
    API.get(`/customers/${customerId}`)
      .then(res => {
        setCustomer(res.data);
        setPrice(res.data.price || 0);
        setAdvance(res.data.advance_amount || 0);
        setWorkDetails(res.data.work_details || '');
        setDoneDate(res.data.done_date?.substring(0, 10) || '');
      })
      .catch(err => console.error("Customer fetch error:", err));

    API.get(`/customers/users?department=Developer`)
      .then(res => setDevelopers(res.data))
      .catch(err => console.error("Developers fetch error:", err));
  }, [customerId]);

  const fetchSalesTeamName = async (salesteam_id) => {
  try {
    const res = await API.get(`/employees/${salesteam_id}`);
    return res.data.employee.full_name || 'Unknown Sales';
   
  } catch (err) {
    console.error('Sales team fetch error', err);
    return 'Unknown Sales';
  }
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();

    formData.append('developerteam_id', e.target.developerteam_id.value);
    formData.append('project_duration', e.target.project_duration.value);
    formData.append('price', price);
    formData.append('advance_amount', advance);
    formData.append('upload_quatation', quotation);
    formData.append('work_details', workDetails);
    formData.append('done_date', doneDate);

    try {
      await API.post(`/customers/${customerId}/mark-done`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

        
        // ✅ Prepare data for activity log
// Get employee ID of current user
const employee_id = JSON.parse(localStorage.getItem('user'))?.employee_id;

// Get developer name from list
const developer = developers.find(d => d.id.toString() === e.target.developerteam_id.value);
const developerName = developer?.name || 'Unknown Developer';

// Fetch salesteam name
    let salesTeamName = '';
    if (customer.salesteam_id) {
      salesTeamName = await fetchSalesTeamName(customer.salesteam_id);
    }

const customerName = customer.customer_name;
const message = `Marked customer "${customerName}" as done. Assigned to developer "${developerName}" and sales team "${salesTeamName}".`;

await addActivity(customer.salesteam_id, message, 'system');


      setModal({
        show: true,
        type: 'success',
        title: 'Success',
        message: 'Customer marked as done successfully!',
      });

      setTimeout(() => {
        setModal({ show: false });
        navigate('/dashboard/done-list');
      }, 2000);
    } catch (err) {
      console.error("Submit error:", err);
      setModal({
        show: true,
        type: 'error',
        title: 'Error',
        message: 'Failed to update customer. Please try again.',
      });
    }
  };

  return (
    <>
      <form
        onSubmit={handleSubmit}
        encType="multipart/form-data"
        className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-lg space-y-5"
      >
        <h4 className="text-xl font-semibold text-gray-700">Mark Customer As Done</h4>

        <div>
          <label className="block mb-1 font-medium">Customer Name</label>
          <input
            type="text"
            className="w-full border border-gray-300 rounded px-3 py-2 bg-gray-100"
            value={customer.customer_name || ''}
            readOnly
          />
        </div>

        <div>
          <label className="block mb-1 font-medium">Assign Developer Team</label>
          <select
            name="developerteam_id"
            className="w-full border border-gray-300 rounded px-3 py-2"
            required
            defaultValue=""
          >
            <option value="">Select Developer</option>
            {developers.map(dev => (
              <option key={dev.id} value={dev.id}>{dev.name}</option>
            ))}
          </select>
        </div>

        <div>
          <label className="block mb-1 font-medium">Upload Quotation (PDF)</label>
          <input
            type="file"
            accept="application/pdf"
            onChange={e => setQuotation(e.target.files[0])}
            className="w-full border border-gray-300 rounded px-3 py-2"
          />
          {customer.upload_quatation && (
            <a
              href={`${API_IMAGE_URL}quotations/${customer.upload_quatation}`}
              target="_blank"
              rel="noopener noreferrer"
              className="block mt-2 text-blue-600 underline"
            >
              View Existing Quotation
            </a>
          )}
        </div>

        <div>
          <label className="block mb-1 font-medium">Project Duration</label>
          <input
            type="text"
            name="project_duration"
            defaultValue={customer.project_duration || ''}
            className="w-full border border-gray-300 rounded px-3 py-2"
          />
        </div>

        <div>
          <label className="block mb-1 font-medium">Work Details</label>
          <textarea
            rows={3}
            className="w-full border border-gray-300 rounded px-3 py-2"
            value={workDetails}
            onChange={e => setWorkDetails(e.target.value)}
          />
        </div>

        <div>
          <label className="block mb-1 font-medium">Done Date</label>
          <input
            type="date"
            className="w-full border border-gray-300 rounded px-3 py-2"
            value={doneDate}
            onChange={e => setDoneDate(e.target.value)}
            required
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block mb-1 font-medium">Price (₹)</label>
            <input
              type="number"
              className="w-full border border-gray-300 rounded px-3 py-2"
              value={price}
              onChange={e => setPrice(Number(e.target.value))}
            />
          </div>
          <div>
            <label className="block mb-1 font-medium">Advance (₹)</label>
            <input
              type="number"
              className="w-full border border-gray-300 rounded px-3 py-2"
              value={advance}
              onChange={e => setAdvance(Number(e.target.value))}
            />
          </div>
          <div>
            <label className="block mb-1 font-medium">Due Amount (₹)</label>
            <input
              type="number"
              className="w-full border border-gray-300 rounded px-3 py-2 bg-gray-100"
              value={price - advance}
              readOnly
            />
          </div>
        </div>

        <div className="pt-4">
          <button
            type="submit"
            className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded font-medium"
          >
            Update & Mark Done
          </button>
        </div>
      </form>

      {modal.show && (
        <MessageModal
          show={modal.show}
          onClose={() => setModal({ ...modal, show: false })}
          type={modal.type}
          title={modal.title}
          message={modal.message}
        />
      )}
    </>
  );
};

export default CustomerMarkDone;
